<portal-sub-nav [force]="force" route="enterprise-journal">
  <portal-menu-context [heading]="'menu.journal.title' | portalTranslate"></portal-menu-context>

  <!-- History -->
  <portal-sub-nav-item route="enterprise-journal-history">
    <ng-template portalTransclude>
      <span>{{ 'menu.journal' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Call Details -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_CDR],
    }"
    route="enterprise-journal-call-details"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.cdr' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>
</portal-sub-nav>
